export default "__VITE_ASSET__CFna2tHr__"